<template>
    <div class="modal fade" id="updateClientModal" role="dialog" aria-labelledby="eventModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable" role="document">
            <div class="modal-content">
                <div class="modal-header-image">
                    <h3>Editar Base Cliente</h3>
                </div>
                <preloader v-if="loading"></preloader>
                <div class="modal-body">
                    <div class="form-group">
                        <label for="descripcion">Descripción:</label>
                        <input type="text" class="form-control" name="descripcion" v-model="form.descripcion" max="100" placeholder="Descripción">
                        <div v-if="errors && errors.descripcion" class="text-danger">
                            {{ errors.descripcion[0] }}
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="descripcion">Límite Usuarios:</label>
                        <input type="number" class="form-control" name="limite_usuarios" v-model="form.limite_usuarios" max="100">
                         <div v-if="errors && errors.limite_usuarios" class="text-danger">
                            {{ errors.limite_usuarios[0] }}
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="descripcion">Base de datos:</label>
                        <input type="text" class="form-control" name="base_datos" v-model="form.base_datos" max="150">
                        <div v-if="errors && errors.base_datos" class="text-danger">
                            {{ errors.base_datos[0] }}
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="descripcion">
                            Número de registros por paginación:
                        </label>
                        <input type="number" class="form-control" name="paginacion" v-model="form.paginacion" min="0">
                        <div v-if="errors && errors.paginacion" class="text-danger">
                            {{ errors.paginacion[0] }}
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <a href="#!" v-on:click.prevent="cancelCliente">
                        Cancelar
                    </a>

                    <button v-on:click.prevent="updateCliente" :disabled="loading">
                        Actualizar
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        mounted: function() {
            //
        },

        data(){
            return {
                loading: false,
                form: {
                    codigo_cliente: '',
                    descripcion: '',
                    limite_usuarios: 0,
                    base_datos: 'JESTRADA_CRM_',
                    paginacion: 0,
                },
                errors: {},
            };
        },

        methods: {
            edit(id){
                var url = 'api/clienteBases/'+id;
                
                axios.get(url)
                    .then(response => {
                        this.form.codigo_cliente = response.data.CODIGO_CLIENTE;
                        this.form.descripcion = response.data.DESCRIPCION;
                        this.form.limite_usuarios = response.data.LIMITE_USUARIOS;
                        this.form.base_datos = response.data.BASE_DATOS;
                        this.form.paginacion = response.data.PAGINACION;
                    })
                    .catch(error => {
                        console.log(error.response);
                        this.$toasted.show('Error al leer información');
                    }).then(()=>{
                        this.loading = false;
                    });
                $('#updateClientModal').modal('show');
            },

            updateCliente() {
                var url = '/api/clienteBases/'+this.form.codigo_cliente;
                this.persistClient(
                    'put', url,
                    this.form, '#updateClientModal', 'Cliente Actualizado', 'Error Actualizando Cliente'
                );
            },

            cancelCliente(){
                $('#updateClientModal').modal('hide');
            },

            persistClient(method, uri, form, modal, messageSuccess, messageError) {
                form.errors = [];
                this.loading = true;
                axios[method](uri, form)
                    .then(response => {
                        $(modal).modal('hide');
                        this.$toasted.show(messageSuccess);
                        location.reload();
                    })
                    .catch(error => {
                        console.log(error.response);
                        this.$toasted.show(messageError);
                        if (error.response.status === 422) {
                            this.errors = error.response.data.errors || {};
                        }
                    }).then(()=>{
                        this.loading = false;
                    });
            },
        },
    }
</script>
